import axios from "axios";
import ENV from "../configs/env.config";
import { parseJwt } from "../utils";
import { auth } from "../utils/auth";
const SERVER_URL = ENV.SERVER_URL;
const AUTH_SERVER = SERVER_URL + "/iam";
const PROFILE_SERVER = SERVER_URL + "/profile";
const USER_SERVER = SERVER_URL + "/user";
const COGNITO_SERVER = SERVER_URL + "/auth";
const REPORT_SERVER = SERVER_URL + "/cloud-report-service";
const DEV_SERVER = "http://35.165.212.63:3030/iam"
// const PROFILE_SERVER = "https://ezqib1sva9.execute-api.us-west-2.amazonaws.com/authorizer-test/profile";
// const AUTH_SERVER = "https://ezqib1sva9.execute-api.us-west-2.amazonaws.com/test/iam"
const REFRESH_API = USER_SERVER + '/refresh2';
const LOGIN_API = COGNITO_SERVER + '/login';
const TRANSLATION_URL = SERVER_URL + "/msp-multi-language-support-service";

let isRefreshing = false;
let refreshTokenPromise = null;

const refreshExceptions = [
    REFRESH_API, COGNITO_SERVER + '/login', USER_SERVER + '/reset', USER_SERVER + '/confirm', COGNITO_SERVER + "/migrateauth"
]

export function axiosWithTokenRefresh(axiosRequest) {
    return function() {
        return axiosRequest();
    }
}


// apis without auth control

export function authenticate(userName, password) {
    return axios.post(LOGIN_API, {
            userName: userName, 
            password: password
    },
    {
        withCredentials: true,
        timeout: 25000,
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        }
    })
}

export function forgetPassword(userName, metadata) {
    return axios({
        url: USER_SERVER + '/reset',
        // url: "http://35.165.212.63:3001/user/reset",
        method: "POST",
        data: {
            userName,
            metadata: metadata,
        },
        timeout: 25000
    })
}

export function confirmChangePassword(username, password, verification) {
    return axios({
        url: USER_SERVER + '/confirm',
        method: "POST",
        data:  {
            userName: username, 
            verificationCode: verification, 
            newPassword: password
        },
        timeout: 25000
    })
}

export const changePassword = (userName, password, newPassword) => {
    return axios({
        url: COGNITO_SERVER + '/login',
        method: "POST",
        data: {
            userName: userName, 
            password: password,
            newPassword: newPassword
        },
        timeout: 25000
    })
}

// apis under auth control

export const register = (fromDomain, fromMerchantId, 
                        userName, email, firstName, lastName, phone, 
                        toDomain, toMerchantId) => {
    return axios({
        // url: "http://34.210.146.38/reg",
        url: USER_SERVER + "/create",
        method: "POST",
        data: {
        "userName": userName, 
        "email": email, 
        "firstName": firstName,
        "lastName": lastName, 
        "phone": phone,
        "domain": toDomain, 
        "merchantId": toMerchantId
    },
    headers: {
        "_domain": fromDomain,
        "_merchantid": fromMerchantId
    },
        timeout: 25000
    })
}

export const getAccounts = (fromDomain, fromMerchantId, domain, merchants, userId, isBusinessOwner, withAssumedDetail) => {
    return axios({
        url: AUTH_SERVER + "/account/listAccounts",
        // url: DEV_SERVER + "/account/listAccounts",
        params: {domain, merchants, userId, isBusinessOwner, withAssumedDetail},
        method: "GET",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const getAccountList = (fromDomain, fromMerchantId, domain, merchants, userId, isBusinessOwner, withAssumedDetail, pagination) => {
    return axios({
        url: AUTH_SERVER + "/account/getAccountList",
        // url: DEV_SERVER + "/account/getAccountList",
        params: {
            domain, merchants, userId, isBusinessOwner, withAssumedDetail, 
            page: pagination ? pagination.page: undefined, 
            countPerPage: pagination ? pagination.countPerPage: undefined},
        method: "GET",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const searchAccount = (fromDomain, fromMerchantId, filter, merchants, isBusinessOwner, withAssumedDetail, pagination) => {
    console.log({pagination});
    const {domain, name, username, business, merchant} = filter;
    return axios({
        url: AUTH_SERVER + "/account/search",
        params: {
            domain, name, username, business, merchant, merchants, isBusinessOwner, withAssumedDetail, 
            page: pagination ? pagination.page: undefined, 
            countPerPage: pagination ? pagination.countPerPage: undefined},
        method: "GET",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const getAccount = (domain, merchantId, userId) => {
    return axios({
        url: AUTH_SERVER + "/account/getAccount",
        params: {domain, merchantId, userId},
        method: "GET",
        headers: {
            "_domain": domain,
            "_merchantid": merchantId
        },
        timeout: 25000
    })
}

export const setAccountRole = (domain, merchantId, userId, roleName) => {
    return axios({
        url: AUTH_SERVER + "/account/setCurrentRole",
        method: "POST",
        params: {
            domain, merchantId, userId, roleName
        },
        headers: {
            "_domain": "M",
            "_merchantid": "menusifu"
        },
        timeout: 25000
    })
}

export const assignRole = (fromDomain, fromMerchantId, toDomain, merchants, toUserId, roles) => {
    return axios({
        url: AUTH_SERVER + "/account/assignRole",
        params: {
            userId: toUserId, 
            domain: toDomain, 
            merchants, 
            roles
        },
        method: "POST",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const removeRole = (fromDomain, fromMerchantId, toDomain, merchants, toUserId, roles) => {
    return axios({
        url: AUTH_SERVER + "/account/removeRole",
        params: {
            userId: toUserId, 
            domain: toDomain, 
            merchants, 
            roles
        },
        method: "POST",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const inviteAccount = (fromDomain, fromMerchantId, 
                              toDomain, toMerchantId, toUserId, businessOwner) => {
    return axios({
        url: AUTH_SERVER + "/account/inviteAccount",
        method: "POST",
        params: {
            domain: toDomain, 
            userId: toUserId, 
            merchants: toMerchantId,
            businessOwner
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const deleteAccount = (fromDomain, fromMerchantId, toDomain, toMerchantId, toUserId) => {
    return axios({
        url: AUTH_SERVER + "/account/deleteAccount",
        method: "POST",
        params: {
            domain: toDomain, 
            userId: toUserId, 
            merchants: toMerchantId
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const listPermissionInDomain = (fromDomain, fromMerchantId, toDomain, toMerchantId) => {
    return axios({
        url: AUTH_SERVER + "/permission/listPermissionsInDomain",
        method: "GET",
        params: {
            domain: toDomain,
            merchantId: toMerchantId
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const listAllResource = () => {
    return axios({
        url: AUTH_SERVER + "/resource/listAll",
        method: "GET",
        headers: {
            "_domain": "M",
            "_merchantid": "menusifu"
        },
        params: {
            domain: "M"
        },
        timeout: 25000
    })
}

export const listProfile = (fromDomain, fromMerchantId, userId) => {
    return axios({
        url: `${PROFILE_SERVER}/users${userId ? "/" + userId : ""}`,
        method: "GET",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        timeout: 25000
    })
}

export const createProfile = (fromDomain, fromMerchantId, sub, firstname, lastname, phone, email) => {
    return axios({
        url: PROFILE_SERVER + "/users",
        method: "POST",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        data: {
            sub, firstname, lastname, phone, email
        },
        timeout: 25000
    })
}

export const updateProfile = (sub, updates, fromDomain, fromMerchantId) => {
    return axios({
        url: PROFILE_SERVER + `/users/${sub}`,
        method: "PUT",
        data: updates,
        timeout: 25000,
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const searchMerchantFromMSS = (fromDomain, fromMerchantId, keyword) => {
    return axios({
        url: AUTH_SERVER + "/merchant",
        params: {
            search: keyword
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const searchCognitoUsers = (fromDomain, fromMerchantId, phone, email) => {
    return axios({
        url: AUTH_SERVER + "/account/cognitoUsers",
        params: {
            phone, email
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const listChainMerchants = (fromDomain, fromMerchantId, resource) => {
    return axios({
        url: AUTH_SERVER + "/account/listChainMerchants",
        params: {
            resource
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const listAuthorizedMerchants = (business, resource, attributes) => {
    return axios({
        url: AUTH_SERVER + "/account/listAuthorizedMerchants",
        params: {
            resource,
            attributes,
            business
        }
    })
}

export const getMerchantGroups = (fromDomain, fromMerchantId, ids) => {
    return axios({
        url: AUTH_SERVER + "/merchant/group",
        method: "GET",
        params: {
            merchants: ids
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const addMerchantToGroup = (fromDomain, fromMerchantId, merchants, groupName) => {
    console.log({merchants});
    return axios({
        url: AUTH_SERVER + "/merchant/group",
        method: "POST",
        params: {
            merchants: merchants,
            groupName: groupName
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const removeMerchantFromGroup = (fromDomain, fromMerchantId, merchants, groupName) => {
    return axios({
        url: AUTH_SERVER + "/merchant/group",
        method: "DELETE",
        params: {
            merchants: merchants,
            groupName: groupName
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const accountHasPermission = (fromDomain, fromMerchantId, merchants, roles) => {
    return axios({
        url: AUTH_SERVER + "/account/hasPermission",
        method: "GET",
        params: {
            merchants: merchants,
            roles: roles
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const setBusinessName = (fromDomain, fromMerchantId, merchants, business) => {
    return axios({
        url: AUTH_SERVER + "/merchant/business",
        method: "POST",
        data: {
            business: business
        },
        params: {
            merchants: merchants
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const customSettings = (fromDomain, fromMerchantId, domain, merchants, userId, settings) => {
    return axios({
        url: AUTH_SERVER + "/account/customSettings",
        method: "POST",
        data: {
            ...settings
        },
        params: {
            domain, merchants, userId
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const getMerchantCustomSettings = (fromDomain, fromMerchantId, domain, merchants) => {
    return axios({
        url: AUTH_SERVER + "/merchant/customSettings",
        method: "GET",
        params: {
            domain, merchants
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const fetchMenuList = (fromDomain, fromMerchantId) => {
    return axios({
        url: REPORT_SERVER + "/fetchMenuList",
        method: "GET",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const resendInitialPassword = (fromDomain, fromMerchantId, userName) => {
    return axios({
        url: USER_SERVER + "/resend",
        method: "POST",
        data: { userName },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const assumeRole = (fromDomain, fromMerchantId, domain, merchantId, userId, targetAccounts) => {
    return axios({
        url: AUTH_SERVER + "/account/assumedRoles",
        method: "POST",
        data: { targetAccounts},
        params: {
            domain, merchantId, userId
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const removeAssumedRole = (fromDomain, fromMerchantId, domain, merchantId, userId, targetAccounts) => {
    return axios({
        url: AUTH_SERVER + "/account/assumedRoles",
        method: "DELETE",
        data: { targetAccounts},
        params: {
            domain, merchantId, userId
        },
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export const createMerchantGroup = (_body, _header) => {
    return axios({
        url: AUTH_SERVER + "/merchant/group/createGroup",
        method: "POST",
        data: _body,
        headers: _header
    })
}

export const insertMerchantsToGroup = (_body, _domain, _merchants, _merchantid) => {
    return axios({
        url: AUTH_SERVER + "/merchant/group/insertMerchant",
        method: "POST",
        data: _body,
        headers: {
            "_domain": _domain,
            "merchants": _merchants,
            "_merchantid": _merchantid
        }
    })
}

export const removeMerchantsFromGroup = (_body, _merchants, _domain, _merchantid) => {
    return axios({
        url: AUTH_SERVER + "/merchant/group/removeMerchant",
        method: "POST",
        data: _body,
        headers: {
            "merchants": _merchants,
            _domain: _domain,
            _merchantid: _merchantid
        }
    })
}

export const editMerchantGroup = (_body, _header) => {
    return axios({
        url: AUTH_SERVER + "/merchant/group/editGroup",
        method: "POST",
        data: _body,
        headers: _header
    })
}

export const deleteMerchantGroup = (_body, _header) => {
    return axios({
        url: AUTH_SERVER + "/merchant/group/deleteGroup",
        method: "POST",
        data: _body,
        headers: _header
    })
}

export const setMerchantAlias = (_body, _params, _header) => {
    return axios({
        url: AUTH_SERVER + "/merchant/alias",
        method: "POST",
        data: _body,
        params: _params,
        headers: _header
    })
}

// export const clearRefreshCookie = () => {
//     return axios({
//         url: COGNITO_SERVER + "/clear",
//         method: "GET"
//     })
// }

export function clearRefreshCookie() {
    return axios.get(COGNITO_SERVER + "/clear", 
    {
        withCredentials: true,
        timeout: 25000,
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        }
    })
}

export function getUserStatus(username) {
    return axios({
        url: AUTH_SERVER + "/account/userStatus",
        method: "GET",
        params: { username }
    })
}

export function getTranslations() {
    return axios({
        url: TRANSLATION_URL + "/translationTool",
        method: "GET"
    })
}

export function addTranslation(_data) {
    return axios({
        url: TRANSLATION_URL + "/translationTool",
        method: "POST",
        data: _data
    })
}

export function updateTranslations(_data) {
    return axios({
        url: TRANSLATION_URL + "/translationTool",
        method: "PUT",
        data: _data
    })
}

export function deleteTranslation(_data) {
    return axios.delete(
        TRANSLATION_URL + "/translationTool",
        {
            data: _data
        }
    )
}

export function publishTranslations() {
    return axios({
        url: TRANSLATION_URL + "/translationTool/publish",
        method: "GET"
    })
}

export function internalUpdateTranslations() {
    return axios({
        url: TRANSLATION_URL + "/internalUpdateTranslations",
        method: "GET"
    })
}

export function translate(textArray, locale) {
    return axios({
        url: TRANSLATION_URL + "/translationServe",
        method: "POST",
        data: { textArray, locale }
    })
}

export function sendAttrVerify(attr, access) {
    return axios({
        url: USER_SERVER + "/sendAttributeVerification",
        method: "POST",
        data: {attr, access}
    })
}

export function updateAttribute(attr, access, newAttr, verifyCode) {
    return axios({
        url: USER_SERVER + "/updateAttribute",
        method: "PUT",
        data: {
            attr, access, 
            attributes: [{
                ...newAttr
            }],
            verificationCode: verifyCode
        }
    })
}

export function verifyAttribute(attr, access, verificationCode) {
    return axios({
        url: USER_SERVER + "/verifyAttribute",
        method: "POST",
        data: {
            attr, access, verificationCode
        }
    })
}

export function getNewAttrAvailability(email, phone) {
    return axios({
        url: AUTH_SERVER + "/profile/newAttributeAvailability",
        method: "GET",
        params: {
            email, phone
        }
    })
}

export function getUserAliasIdStatus(sub) {
    return axios({
        url: AUTH_SERVER + "/profile/aliasIdStatus/" + sub,
        method: "GET"
    })
}
 
export function getBusinessById(fromDomain, fromMerchantId, id) {
    return axios({
        url: AUTH_SERVER + "/business/id/" + id,
        method: "GET",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        }
    })
}

export function getBusinessList(fromDomain, fromMerchantId, pagination, filter, sort) {
    return axios({
        url: AUTH_SERVER + "/business/list",
        method: "GET",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        params: { 
            page: pagination ? pagination.page: undefined, 
            countPerPage: pagination ? pagination.countPerPage: undefined,
            order: sort ? sort.order: undefined,
            orderBy: sort ? sort.orderBy: undefined,
            ...filter
        },
    })
}

export function getBusinessList2(fromDomain, fromMerchantId, pagination, search, sort) {
    return axios({
        url: AUTH_SERVER + "/business/list2",
        method: "GET",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        params: { 
            page: pagination ? pagination.page: undefined, 
            countPerPage: pagination ? pagination.countPerPage: undefined,
            order: sort ? sort.order: undefined,
            orderBy: sort ? sort.orderBy: undefined,
            search
        },
    })
}

export function saveBusiness(fromDomain, fromMerchantId, newBusiness) {
    return axios({
        url: AUTH_SERVER + "/business/save",
        method: "POST",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        data: { 
            ...newBusiness
        },
    })
}

export function deleteBusiness(fromDomain, fromMerchantId, id) {
    return axios({
        url: AUTH_SERVER + "/business/delete",
        method: "DELETE",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        data: { 
            _id: id
        },
    })
}

export function legacyLogin(username, email, password, service) {
    return axios({
        url: COGNITO_SERVER + "/migrateauth",
        method: "POST",
        data: {
            userName: username,
            password: password,
            ClientMetadata: {
                email: email,
                service
            }
        }
    })
}

export function migrate(service, token) {
    return axios({
        url: AUTH_SERVER + "/migrate",
        method: "POST",
        headers: {
            token
        },
        data: {
            service: service
        }
    })
}

export function getUsername(email) {
    return axios({
        url: AUTH_SERVER + "/account/getUsername",
        data: {
            email
        },
        method: "POST",
    })
}

export function updateIdAlias(fromDomain, fromMerchantId, sub, email, phone) {
    let data = {};
    if (email) {
        data.email = email;
    }
    if (phone) {
        data.phone = phone;
    }
    return axios({
        url: AUTH_SERVER + "/profile/updateIdAlias/" + sub,
        method: "POST",
        headers: {
            "_domain": fromDomain,
            "_merchantid": fromMerchantId
        },
        data: data
    })
}

export function getPaswordRecoverMethods({ email, phone }) {
    return axios({
        url: COGNITO_SERVER + "/recoverPasswordMethods",
        data: {
            phone, email
        },
        method: "POST"
    })
}


export function authorizeClient(redirect_uri, code_challenge, code_challenge_method, scope) {
    let params = { redirect_uri };
    if (code_challenge && code_challenge_method) {
        params = {
            ...params,
            code_challenge, 
            code_challenge_method
        }
    }
    if (scope && scope !== "undefined") {
        params = {
            ...params,
            scope
        }
    }
    return axios({
        method: "GET",
        params: params,
        url: `${SERVER_URL}/idp/authorize`,
        withCredentials: true
    })
}

export function oauth2_login(redirect_uri, code_challenge, code_challenge_method, username, password, scope) {
    let params = { redirect_uri };
    if (code_challenge && code_challenge_method) {
        params = {
            ...params,
            code_challenge, 
            code_challenge_method
        }
    }
    if (scope && scope !== "undefined") {
        params = {
            ...params,
            scope
        }
    }
    let data = {};
    if (username && password) {
        data = {
            username, password
        }
    }
    return axios({
        method: "POST",
        url: `${SERVER_URL}/idp/login`,
        params, data,
        withCredentials: true
    })
}

export function temp_oauth2_login(redirect_uri, code_challenge, code_challenge_method, username, password, scope) {
    let params = { redirect_uri };
    if (code_challenge && code_challenge_method) {
        params = {
            ...params,
            code_challenge, 
            code_challenge_method
        }
    }
    if (scope && scope !== "undefined") {
        params = {
            ...params,
            scope
        }
    }
    let data = {};
    if (username && password) {
        data = {
            username, password
        }
    }
    return axios({
        method: "POST",
        url: `${SERVER_URL}/idp/temp-login`,
        params, data,
        withCredentials: true
    })
}

export function oauth2_logout() {
    return axios({
        url: `${SERVER_URL}/idp/logout`,
        method: 'GET',
        withCredentials: true
    });
}

export function oauth2_mfa(redirect_uri, code_challenge, code_challenge_method, authentication_code, scope) {
    let params = { redirect_uri };
    if (code_challenge && code_challenge_method) {
        params = {
            ...params,
            code_challenge, 
            code_challenge_method
        }
    }
    if (scope && scope !== "undefined") {
        params = {
            ...params,
            scope
        }
    }
    let data = {};
    if (authentication_code) {
        data = {
            authentication_code
        }
    }
    return axios({
        method: "POST",
        url: `${SERVER_URL}/idp/mfa`,
        params, data,
        withCredentials: true
    })
}

export function resendMfaCode(redirect_uri, code_challenge, code_challenge_method, scope) {
    let params = { redirect_uri };
    if (code_challenge && code_challenge_method) {
        params = {
            ...params,
            code_challenge, 
            code_challenge_method
        }
    }
    if (scope && scope !== "undefined") {
        params = {
            ...params,
            scope
        }
    }
    return axios({
        method: "POST",
        url: `${SERVER_URL}/idp/resend-mfa`,
        params,
        withCredentials: true
    })
}

// Check MFA session status
export function checkMFASession() {
    return axios.get(`${SERVER_URL}/idp/check-mfa-session`, {
        withCredentials: true,
        timeout: 25000,
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        }
    });
}

// Debug cache endpoint
export function debugCache() {
    return axios.get(`${SERVER_URL}/idp/debug-cache`, {
        withCredentials: true,
        timeout: 25000,
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        }
    });
}

// Clear cognito session for fresh login
export function clearCognitoSession() {
    return axios.post(`${SERVER_URL}/idp/clear-cognito-session`, {}, {
        withCredentials: true,
        timeout: 25000,
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        }
    });
}

